import type { AdminKpisDateFilterProps } from "../../models/admin-kpis.models";
import { memo } from "react";

const DateFilter = ({ label, value, dataTest, onChange }: AdminKpisDateFilterProps) => {
  return (
    <label className="block" data-test={dataTest}>
      <span className="mb-1 block text-[11px] font-medium text-[#6B7473] dark:text-gray-300">{label}</span>
      <input
        type="date"
        value={value}
        className="h-9 w-full border border-[#D7E2DE] bg-white px-2 text-xs outline-none focus:border-green dark:border-gray-700 dark:bg-gray-900"
        onChange={(event) => onChange(event.target.value)}
      />
    </label>
  );
};

export default memo(DateFilter);
